/**
 * Creates a custom error with additional metadata
 *
 * @param {string} message - The error message to be displayed
 * @param {Object} [metadata] - Optional metadata object providing additional context about the error
 * @returns {Error} A custom error object with an additional metadata property
 *
 * @example
 * const error = createDetailedError('Validation failed', {
 *   field: 'username',
 *   reason: 'too short'
 * });
 * console.log(error.message);     // 'Validation failed'
 * console.log(error.metadata);    // { field: 'username', reason: 'too short' }
 */
export default function createDetailedError (message, metadata) {
  const error = new Error(message);
  error.metadata = metadata;
  return error;
}
